import useDashboard from "../useDashboard";
import SelectInput from "../../shared/SelectInput";
import React from "react";

const StartTimeFilter = () => {
    const { startTimeFilter, setFilter } = useDashboard();

    return startTimeFilter ? (
        <SelectInput
            label="Start time"
            options={startTimeFilter.options}
            isDisabled={false}
            onChangeHandler={(e) => {
                setFilter(e, startTimeFilter.filterName);
            }}
            selectedValue={startTimeFilter.selectedValue}
        />
    ) : null;
};

export default StartTimeFilter;
